import React from "react";
import useScreenResolution from "../../../hooks/useScreenResolution";

const shimmer =
  "relative overflow-hidden bg-[#EEF2F4] before:absolute before:inset-0 before:-translate-x-full before:animate-[offersShimmer_1.4s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/60 before:to-transparent";

const Bar = ({ className = "" }) => (
  <span className={`block rounded-md ${shimmer} ${className}`} />
);

const OffersSkeleton = ({ showTitle = true }) => {
  const { mobile } = useScreenResolution();

  return (
    <>
      <style>{`@keyframes offersShimmer { 100% { transform: translateX(100%); } }`}</style>

      {showTitle && (
        <Bar
          className={`h-7 ${mobile ? "w-40 mb-3" : "w-48 mb-2"}`}
        />
      )}

      <div className="banner-carousel-section" aria-hidden="true">
        <div className="slider-container">
          <div className="flex items-center justify-center">
            <Bar
              className={`${
                mobile
                  ? "w-full h-[160px] rounded-[16px]"
                  : "w-full max-w-[1100px] h-[220px] rounded-[20px]"
              }`}
            />
          </div>

          <div className="custom-dots-container flex items-center justify-center gap-2 mt-4">
            <Bar className="h-2 w-2 rounded-full" />
            <Bar className="h-2 w-6 rounded-full" />
            <Bar className="h-2 w-2 rounded-full" />
          </div>
        </div>
      </div>
    </>
  );
};

export default OffersSkeleton;
